import React from 'react';
import { useEffect, useState, useContext } from 'react';
import styled from 'styled-components';
import { Button } from '../UI';
import { shortenAddress } from '../utils/shortenAddress';
import { unilendV2poolABI, PositionABI } from '../constants/abis';
import { getTokenLogo, getToken, getTokenByAddress } from '../constants/logos';
import { WalletContext } from '../context/WalletContext';
import { allTransaction } from '../services/tokenData';
import breakpoints from '../utils/breakpoints';
import transError from '../images/transError.svg';
import ReactPaginate from 'react-paginate';
import right from '../images/right.svg';
import left from '../images/left.svg';
import sort from '../images/sort.svg';
import tx from '../images/tx.svg';
import Lottie from 'react-lottie';
import Loader from '../lotties/loading.json';
// import eclipseLoader from "../../public/Eclipse-loader.gif"

const HistoryWrapper = styled.div`
  box-sizing: border-box;
  width: 1206px;
  height: 100%;
  margin: 50px auto;
  padding:20px;
  background: #ffffff;
  border: 0.01px solid #fff;
  border-radius: 21.6925px;
  position: relative;

  @media ${breakpoints.device.sm} {
    height: 100%;
    width: 343px;
    padding: 14.45px 20px;
  }

  @media ${breakpoints.device.md} {
    height: 100%;
    width: 750px;
    padding: 14.45px 20px;
  }

  @media ${breakpoints.device.lg} {
    width: 1206px;
    height: 100%;
    padding: 14.45px 43px;
  }

  .historyInner {
    padding: 0;

    @media ${breakpoints.device.md} {
      padding: 0;
    }

    @media ${breakpoints.device.lg} {
      padding: 0;
    }
  }

  .searchBar{
    width: 411px;
    height: 52px;
    border: 1px solid #E6EEF9;
    background: #E6EEF9;
    border-radius: 5.77909px;
    outline: none;
    padding: 0px 20px;

    @media ${breakpoints.device.sm} {
      width: 201px;
      height:38px;
    }
  }

  .action-buttons{
    display: flex;
    justify-content: space-between;
    align-items:center;
    padding:25px 0 39px 0;
  }

  .sort_dropDown{
    position: absolute;
    width:137px;
    height: 85px;
    background: #FFFFFF;
    box-shadow: -1px -1px 2px rgba(0, 0, 0, 0.08), 2px 2px 2px rgba(0, 0, 0, 0.13);
    border-radius: 7px;
    padding: 10px 8px;
    top: 83px;
    right:30px;
    z-index:10;

    
  }


  .sort{
    font-family: 'Public Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 11px;
    line-height: 11px;
    display: flex;
    align-items: center;
    text-align:center;
    color: #808080;
    padding:5px 6px;
    cursor: pointer;
    p{
      margin: 0px;
      padding: 7px;
    }
  }
   
  .sort_active{
    color: #808080;
    background: #DBEAFF;
    border-radius: 3.77769px;
    display:flex;
    align-items: center;
  }

  .searchBar::placeHolder{
    font-family: 'Public Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 14.3497px;
    line-height: 24px;
    color: #C4C4C4;
  }

  .historyInnerContentsHeaders{
    @media ${breakpoints.device.sm} {
      display:none;
    }
  }

  .mobile-historyInnerContentsHeaders ul {
    display:none;
    @media ${breakpoints.device.sm} {
      display: grid;
      grid-template-columns: 30px 60px 45px 40px;
      justify-content:space-between;
      font-family: 'Public Sans';
      font-style: normal;
      font-weight: 700;
      font-size: 13.2127px;
      line-height: 16px;
      color: #000000;
      margin-bottom:47px;
    }
  }

  .mobile-historyInnerContentsHeaders hr {
    @media ${breakpoints.device.sm} {
      display:none;
    }
  }

  .historyInnerContentsHeaders ul {
    display: grid;
    grid-template-columns: 150px 70px 55px 50px 30px 150px;
    justify-content:space-between;

  }

  .historyInnerContentsHeaders ul li{
    font-family: 'Public Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: flex-end;

    color: #000000;


    @media ${breakpoints.device.sm} {
      font-size: 13px;
    }

    @media ${breakpoints.device.md} {
      font-size: 13px;

    }

    @media ${breakpoints.device.lg} {
      font-size: 16px;

    }
  }

  .historyInnerContentsHeaders li .type{
    @media ${breakpoints.device.sm} {
      display:none;
    }
  }

  .historyInner hr{
    border: 0.8px solid rgba(169, 169, 169, 0.5);
    margin-top: 15px;
    width:100%;

  }

  .historyInnerContents ul{
    .pools{
      position: relative;
      img{
        margin: -5px;
      }
      p{
        margin-left: 10px;
      }
    }
    
    .token{
      font-weight: 600;
      color: #000000;
      @media ${breakpoints.device.sm} {
        display:none;
      }
    }

    .txid{
      font-weight: 600;
      color: #000000;
      @media ${breakpoints.device.sm} {
        display:none;
      }
    }

    .mobile-txid{
      @media ${breakpoints.device.sm} {
        display:block;
        cursor:pointer;
      }

      @media ${breakpoints.device.lg} {
        display:none;
      }
    }

    .type{
      font-weight: 600;
      color: #000000;
      @media ${breakpoints.device.sm} {
        display:none;
      }
    }

    .mobileToken{
      
      @media ${breakpoints.device.lg} {
        display:none;
      }
    }

    .date, .txStatus{
      font-size:13px;
      font-weight: 600;
      @media ${breakpoints.device.sm} {
        display:none;
      }
    }

    .amount{
      display:flex;
      justify-content:flex-end;
      font-weight: 600;
    }

    .complete{
      font-weight: 600;
      color: #1ED130;
    }

    .error{
      font-weight: 600;
      color: #FF5353;
    }
  }

  .historyInnerContents ul {
    display: grid;
    grid-template-columns: 150px 70px 55px 50px 30px 150px;
    align-items:center;
    justify-content:space-between;

    @media ${breakpoints.device.sm}{
      grid-template-columns: 20px 150px 20px 20px;
      margin:0;
    } 
  }

  .historyInnerContents li{
    font-family: 'Public Sans';
    font-style: normal;
    font-size: 16px;
    color: #000000;
    padding: 15px 0px;

    @media ${breakpoints.device.sm}{
      font-weight: 600;
      font-size: 13.2127px;
      line-height: 26px;
    }

    @media ${breakpoints.device.md} {
      font-size: 10px;
    }

    @media ${breakpoints.device.lg} {
      font-size: 16px;
    }
  }

  .historyInnerContents .pools{
    display: flex;
    align-items: center;
  }

  .historyInnerContents .pools p{
    margin:0;
    @media ${breakpoints.device.sm} {
      display:none;
    }
  }

  .historyInnerContents .pools img{
    width:31px;
    height:31px;
    margin-right: 10px;
    display:flex;
    align-items:center;

    @media ${breakpoints.device.sm} {
      height:26px;
      width:26px;
    }

    @media ${breakpoints.device.md} {
      height:20px;
      width:20px;
    }

    @media ${breakpoints.device.lg} {
      width:31px;
      height:31px;
    }

  }

  .historyInnerContents .pools .logo2{
    position:absolute;
    left:15px;
  }

  .transactionError{
    text-align:center;
  }

  .transactionError h1{
    color: #DB2438;
    font-family: 'Public Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 29.51px;
    line-height: 35px;
  }

  .paginationButtons{
    width:100%;
    height:40px;
    list-style:none;
    display:flex;
    justify-content:center;
    align-items:flex-end;
  }

  .paginationButtons a{
    padding:10px;
    color: #000;
    border:none;
    
  }
  
  .active{
    border:none;
  }

  .active a{
    color: #0045FF;
  }

  }
`;

const poolData = {
  '0x9Be89Ab05f8730e873f195daF329a0C5Db2ECca4': {
    // poolAddress: '0x40d3b357d8E70bD4a3d1595FBf1AF209F28B7E3c',
    // 0x918fe9e1afa89620e89f9907f4c95c93801a9aa3d7f4aa07d6140cd61713e23e
    poolAddress: '0x9Be89Ab05f8730e873f195daF329a0C5Db2ECca4',
    tokens: ['USDC', 'WETH'],
    supply: '$12,045,000',
    borrowed: '$7,310,455',
  },
  '0xad9E05A861B70Ae2E18C4EC5a3B47B59E65B535E': {
    // poolAddress: '0xc2cb7a0D3721c8D788B01d5140CF919C2cc9B64a',
    poolAddress: '0xad9E05A861B70Ae2E18C4EC5a3B47B59E65B535E',
    tokens: ['DAI', 'WETH'],
    supply: '$1,683,215',
    borrowed: '$897,642',
  },
  '0xAc961A1F91b25ffd24b0FBB43d76d4369bAa2519': {
    // poolAddress: '0x2bC1b550428Bf951E01AdA3b909e191f84c36B6d',
    poolAddress: '0xAc961A1F91b25ffd24b0FBB43d76d4369bAa2519',
    tokens: ['UFT', 'WETH'],
    supply: '$5,302,153',
    borrowed: '$3,817,985',
  },
  '0x445949DDbbf05D5173e9Fc09B48e3B36A2e80e7a': {
    // poolAddress: '0x2bC1b550428Bf951E01AdA3b909e191f84c36B6d',
    poolAddress: '0x445949DDbbf05D5173e9Fc09B48e3B36A2e80e7a',
    tokens: ['UFT', 'USDC'],
    supply: '$3,123,179',
    borrowed: '$2,577,986',
  },
  '0xcC6cd2528aA214784C8AA260442606a20c9891f1': {
    // poolAddress: '0x2bC1b550428Bf951E01AdA3b909e191f84c36B6d',
    poolAddress: '0xcC6cd2528aA214784C8AA260442606a20c9891f1',
    tokens: ['WBTC', 'WETH'],
    supply: '$6,387,157',
    borrowed: '$3,246,700',
  },
  '0xF30A7F4ABF997050241d6a6d9A5D035770AfcfFf': {
    poolAddress: '0xF30A7F4ABF997050241d6a6d9A5D035770AfcfFf',
    tokens: ['USDC', 'DAI'],
    supply: '$5,173,892',
    borrowed: '$2,981,366',
  },
  '0xe5b923a28ad1c2fdA6c6c62D72EA29804C0762eE': {
    poolAddress: '0xe5b923a28ad1c2fdA6c6c62D72EA29804C0762eE',
    tokens: ['UFT', 'OMATIC'],
    supply: '$120,45,000',
    borrowed: '$45,000',
  },
  '0x6176Da7FB5CE111B349b53acC6f89a63d7cF9E54': {
    poolAddress: '0x6176Da7FB5CE111B349b53acC6f89a63d7cF9E54',
    tokens: ['UFT', 'OUSDC'],
    supply: '$120,45,000',
    borrowed: '$45,000',
  },
  '0x0ec289e06B30d0BA30239A45F03be3D5DE875235': {
    poolAddress: '0x0ec289e06B30d0BA30239A45F03be3D5DE875235',
    tokens: ['OUSDC', 'OMATIC'],
    supply: '$120,45,000',
    borrowed: '$45,000',
  },
  '0xB7D0A5D21DE1b1581799cE1EFD78C1D20F731512': {
    poolAddress: '0xB7D0A5D21DE1b1581799cE1EFD78C1D20F731512',
    tokens: ['WBNB', 'BUSD'],
    supply: '$5,173,892',
    borrowed: '$2,981,366',
  },
};

export default function History() {
  const {
    currentAccount,
    isConnected,
    uV2Core,
    connectWallet,
    uV2Helper,
    uWeb3,
  } = useContext(WalletContext);
  const [transactionData, setTransactionData] = useState([]);
  const [transactionDataBackup, setTractionDataBackup] = useState([]);
  const [term, setTerm] = useState('');
  const [dropDown, setDropDown] = useState(false);
  const [active, setActive] = useState(false);
  const [activeId, setActiveId] = useState(1);
  const [noData, setNoData] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pageCount, setpageCount] = useState(0);
  const [content, setContent] = useState([
    { id: 1, name: 'NEW to OLD' },
    { id: 2, name: 'OLD to NEW' },
  ]);
  const [poolContract, setPoolContract] = useState(null);
  const [positionContract, setPositionContract] = useState(null);

  const ousdcImg =
    'https://assets.trustwalletapp.com/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png';

  const uftImg =
    'https://assets.trustwalletapp.com/blockchains/ethereum/assets/0x0202Be363B8a4820f3F4DE7FaF5224fF05943AB1/logo.png';

  const transactionPerPage = 5;
  const pagesVisited = pageNumber * transactionPerPage;

  const navRight = <img src={right} alt='' />;
  const navLeft = <img src={left} alt='' />;

  // const pageCount = Math.ceil(transactionData.length / transactionPerPage);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: Loader,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  useEffect(() => {
    if (!uWeb3) {
      connectWallet();
    }
  }, []);
  useEffect(() => {
    if (uWeb3) {
      const uV2Pool_value = new uWeb3.eth.Contract(
        unilendV2poolABI,
        '0xe5b923a28ad1c2fdA6c6c62D72EA29804C0762eE'
        // UFT-Matic Pool
      );
      setPoolContract(uV2Pool_value);
    }
  }, [uWeb3]);

  useEffect(() => {
    if (uWeb3) {
      const uV2Postion = new uWeb3.eth.Contract(
        PositionABI,
        '0x1D223E31014d436b909225eDd5D0677C93E77622'
      );
      setPositionContract(uV2Postion);
    }
  }, [uWeb3]);

  const getAllTransactionData = async () => {
    setLoading(true);
    const txt = await allTransaction(
      uV2Core,
      positionContract,
      currentAccount,
      uWeb3
    );

    if (txt.length > 0) {
      const sort = txt.sort(function (a, b) {
        // Compare the 2 dates
        if (a.blockNumber < b.blockNumber) return 1;
        if (a.blockNumber > b.blockNumber) return -1;
        return 0;
      });

      setpageCount(Math.ceil(sort.length / transactionPerPage));
      setTransactionData(sort);
      setTractionDataBackup(sort);
    } else {
      setNoData(true);
    }
    setLoading(false);
  };

  useEffect(() => {
    if ((uV2Core, positionContract, uWeb3)) {
      getAllTransactionData();
    }
  }, [uV2Core, positionContract, uWeb3]);

  // useEffect(() => {
  //   let history = JSON.parse(localStorage.getItem("notificationObject"));
  //   if (!history) {
  //     setTransactionData([]);
  //     setNoData(true);
  //   } else {
  //     setTransactionData(history);
  //     setNoData(false);
  //   }
  // }, []);

  const handleNewToOld = () => {
    const sort = transactionData.sort(function (a, b) {
      // Compare the 2 blocknumbers
      if (a.blockNumber < b.blockNumber) return 1;
      if (a.blockNumber > b.blockNumber) return -1;
      return 0;
    });
    setTransactionData(sort);
  };

  const handleOldToNew = () => {
    const sort = transactionData.sort(function (a, b) {
      // Compare the 2 blocknumbers
      if (a.blockNumber < b.blockNumber) return -1;
      if (a.blockNumber > b.blockNumber) return 1;
      return 0;
    });
    setTransactionData(sort);
  };

  const templateDropDown = () => {
    return (
      <div className='sort_dropDown'>
        {content.map((data, id) => (
          <div>
            <div
              onClick={() => {
                setActiveId(data.id);
                if (data.id === 1) {
                  handleNewToOld();
                } else if (data.id === 2) {
                  handleOldToNew();
                }
              }}
              className={`sort ${activeId === data.id && 'sort_active'}`}
            >
              <p>{data.name}</p>
            </div>
          </div>
        ))}
      </div>
    );
  };
  const handleSearch = (value) => {
    setTerm(value);
    const newData = transactionDataBackup.filter((data) => {
      if (value === '') {
        return data;
      } else if (
        getTokenByAddress(data.returnValues._asset)
          ['symbol'].toLowerCase()
          .includes(term.toLocaleLowerCase()) ||
        data.transactionHash.toLowerCase().includes(term.toLocaleLowerCase()) ||
        data.event.toLowerCase().includes(term.toLocaleLowerCase())
      ) {
        return data;
      }
    });
    setpageCount(Math.ceil(newData.length / transactionPerPage));
    setTransactionData(newData);
  };

  return (
    <>
      <HistoryWrapper>
        <div>
          <div className='historyInner'>
            <div className='historyInner'>
              <div className='action-buttons'>
                <div>
                  <input
                    type='text'
                    value={term}
                    onChange={(e) => handleSearch(e.target.value)}
                    placeholder='Search TnX/Token/type'
                    className='searchBar'
                  />
                </div>

                <div>
                  <Button
                    className='style-historyBtn'
                    onClick={() => setDropDown(!dropDown)}
                  >
                    Sort By
                    <img src={sort} alt='' />
                  </Button>
                  <div>{dropDown && templateDropDown()}</div>
                </div>
              </div>

              {loading ? (
                <>
                  <div
                    className='Loading'
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {/* <h1>Fetching Transactions...</h1> */}
                    {/* <Lottie options={defaultOptions} height={400} width={400} /> */}
                    <img width='100px' src='Eclipse-loader.gif' />
                  </div>
                </>
              ) : !loading && !noData ? (
                <>
                  <div className='historyInnerContentsHeaders'>
                    <ul>
                      <li>Pools</li>
                      <li>Token</li>
                      <li>Type</li>
                      <li>Amount</li>
                      <li>Tx Status</li>
                      <li>TxID</li>
                      {/* <li>Date</li> */}
                    </ul>
                  </div>
                  <div className='mobile-historyInnerContentsHeaders'>
                    <ul>
                      <li>Pools</li>
                      <li>Token</li>
                      <li>Amount</li>
                      <li>TxID</li>
                    </ul>
                    <hr />
                  </div>
                  <div>
                    {transactionData
                      .slice(pagesVisited, pagesVisited + transactionPerPage)
                      .map((data) => {
                        return (
                          <>
                            <div className='historyInnerContents' key={data.id}>
                              <ul>
                                <li className='pools'>
                                  <img
                                    src={
                                      getToken(
                                        poolData[data.address].tokens[0]
                                      )['logo']
                                    }
                                    alt=''
                                    srcset=''
                                  />
                                  <img
                                    src={
                                      getToken(
                                        poolData[data.address].tokens[1]
                                      )['logo']
                                    }
                                    alt=''
                                    srcset=''
                                  />
                                  <p>
                                    {poolData[data.address].tokens[0] +
                                      '/' +
                                      poolData[data.address].tokens[1]}
                                  </p>
                                </li>
                                <li className='token'>
                                  {
                                    getTokenByAddress(data.returnValues._asset)[
                                      'symbol'
                                    ]
                                  }
                                </li>
                                <li className='mobileToken'>
                                  {`${
                                    getTokenByAddress(data.returnValues._asset)[
                                      'symbol'
                                    ]
                                  }/${data.event}`}
                                </li>
                                <li className='type'>{data.event}</li>
                                <li className='amount'>
                                  {(
                                    Number(data.returnValues._amount) /
                                    10 ** 18
                                  ).toFixed(4)}
                                </li>
                                <li className={`txStatus complete `}>
                                  Complete
                                </li>
                                <li className='txid'>
                                  <a
                                    href={`https://sepolia.etherscan.io/tx/${data.transactionHash}`}
                                    target='_blank'
                                  >
                                    {shortenAddress(data.transactionHash)}
                                  </a>
                                </li>
                                <li className='mobile-txid'>
                                  <a
                                    href={`https://sepolia.etherscan.io/tx/${data.transactionHash}`}
                                    target='_blank'
                                  >
                                    {' '}
                                    <img src={tx} alt='' />{' '}
                                  </a>
                                </li>
                                {/* <li className="date">date</li> */}
                              </ul>

                              <hr />
                            </div>
                          </>
                        );
                      })}
                  </div>

                  <ReactPaginate
                    previousLabel={navLeft}
                    nextLabel={navRight}
                    pageCount={pageCount}
                    onPageChange={changePage}
                    containerClassName={'paginationButtons'}
                    previousLinkClassName={'previousButton'}
                    nextLinkClassName={'nextBtn'}
                    disabledClassName={'disabled'}
                    activeClassName={'active'}
                  />
                </>
              ) : (
                <>
                  <div className='transactionError'>
                    <img src={transError} alt='' />
                    <h1>No Transactions Found</h1>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </HistoryWrapper>
    </>
  );
}
